import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, generatePath, useParams, useLocation } from "react-router-dom";
import { Html5Qrcode } from "html5-qrcode";

import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarIcons from "./SidebarIcons";
import Toaster from "./common/Toaster";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import LoadingComponent from "./common/LoadingComponent";

import QrAuditTrail from "./QrAuditTrail";

import { LINK_QR_CODES, GET_DOOR_INSPECTION_DATA } from "../api/apiPath";
import http from "../api/server";

const ScanLinkQRCode = ({ renderInComponent = false }) => {
  const location = useParams();
  const { clientNameParam, propertyMasterId, inspectionRefnumber } = location;
  const [hideSidebar, setHideSidebar] = useState(false);
  const { userObj } = useSelector((state) => state.user);
  const [scanOpen, setScanOpen] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);
  const [showAuditPopup, setShowAuditPopup] = useState(false);
  const [auditDoorRef, setAuditDoorRef] = useState(null);

  // const [apiDoorRef, setApiDoorRef] = useState(null);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const [cameras, setCameras] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const html5QrCodeRef = useRef(null);
  const [scannedLink, setScannedLink] = useState(null);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const locationState = useLocation();
  const buildingId = locationState?.state?.buildingId || null;

  useEffect(() => {
    // setIsScanning(true);
    if (scanOpen === true) {
      Html5Qrcode.getCameras()
        .then((devices) => {
          setCameras(devices);
          if (devices.length > 0) setSelectedCameraId(devices[0].id);
          //startScanning();
        })
        .catch((err) => console.error("Camera Error:", err));
    }
  }, [scanOpen]);

  useEffect(() => {
    if (scanOpen === true) {
      if (selectedCameraId && !isScanning) {
        startScanning();
      }
    }
    // eslint-disable-next-line
  }, [selectedCameraId]);

  useEffect(() => {
    if (scanOpen === true) {
      return () => {
        if (html5QrCodeRef?.current?.isScanning) {
          html5QrCodeRef.current
            .stop()
            .then(() => html5QrCodeRef.current.clear())
            .catch(() => {});
        }
      };
    }
  }, [scanOpen]);

  const startScanning = () => {
    setIsScanning(true);
    if (!selectedCameraId) return;
    console.log("selected camera", selectedCameraId);

    html5QrCodeRef.current = new Html5Qrcode("reader");

    html5QrCodeRef.current
      .start(
        selectedCameraId, // ✅ Only pass the camera ID here
        {
          fps: 10,
          qrbox: { width: 300, height: 300 },
        },
        (decodedText) => {
          //let url = decodedText.trim();
          // if (!url.startsWith("http://") && !url.startsWith("https://")) {
          //   url = "https://" + url; // Prepend https if missing
          // }
          console.log("Decoded Text:", decodedText);
          setScannedLink(decodedText);
          const hasRefNo = new URL(decodedText).searchParams.has("refNo");
          const refNo = new URL(decodedText).searchParams.get("refNo");
          const hasEditLink = decodedText.toLowerCase().includes("/editsurvey");
          // if (hasRefNo && refNo != "") {
          //   setIsloading(true);
          //   handleLinkQRCode(refNo);
          if (hasRefNo && refNo != "") {
            setIsloading(true);
            setAuditDoorRef(refNo);
            setShowAuditPopup(true);
          } else if (hasEditLink) {
            // setToastData({
            //   toastShow: true,
            //   toastType: "success",
            //   toastString:
            //     "An inspection for this door already exists, redirecting to edit survey",
            // });
            setScannedLink(decodedText);
            handleCheckEditSurvey(decodedText);
            // setTimeout(() => {
            //   window.open(decodedText, "_blank");
            // }, 2001);
          } else {
            setTimeout(() => {
              setToastData({
                toastShow: true,
                toastType: "failure",
                toastString:
                  "Invalid QR Code scanned. Please scan a valid QR Code or try again.",
              });
            }, 500);
          }
          //window.open(decodedText, "_blank");
          setIsScanning(true);
          stopScanning();
          setIsloading(false);
        },
        (errorMessage) => {
          console.warn("Scan error:", errorMessage);
        }
      )
      .catch((err) => console.error("Start Scan Error:", err));
  };
  const handleLinkQRCode = async (refNo) => {
    const params = new URLSearchParams();
    params.append("PropertyId", propertyMasterId);
    params.append("InspectionRefNo", inspectionRefnumber);
    params.append("QRCodeRefNo", refNo);
    params.append("loggedinUserId", userObj?.userId || 0);
    if(buildingId){
      params.append("BuildingId", buildingId);
    }

    const queryString = params.toString();

    try {
      const response = await http.put(LINK_QR_CODES + `?${queryString}`);
      console.log("Link QR Code Response:", response);
      if (response?.status === 200) {
        const data = response?.data;
        // setApiDoorRef('UC-PS-DRN-0000')
        if (data?.doorMapped && data?.doorRefNo != "") {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "QR Code linked successfully. Please start the survey",
          });
          setTimeout(() => {
            gotoDashBoardLinked(data?.doorRefNo);
          }, 2001);
        } else if (data?.doorMapped === false && data?.doorRefNo != "") {
          try {
            const doorData = await http.get(
              GET_DOOR_INSPECTION_DATA +
                data?.doorRefNo +
                "&propertyMasterId=" +
                propertyMasterId + "&inspectionRefNumber=" + inspectionRefnumber
            );
            if (doorData?.status === 200) {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString:
                  "An inspection for this door already exists, redirecting to edit survey",
              });
              setTimeout(() => {
                gotoEditSurvey(data?.doorRefNo, data?.mappedUrl);
              }, 2001);
            }
          } catch (err) {
            if (err.status === 404) {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString:
                  "QR Code already linked to door. Redirecting to new survey for the same",
              });
              setTimeout(() => {
                  gotoDashBoardMapped(data?.doorRefNo, data?.mapppedUrl);
                }, 2001);
            }
          }
        }
      }
    } catch (err) {
      console.error("Link QR Code Error:", err);
    } finally {
      setIsloading(false);
    }
  };

  const parseSurveyPath = (pathname) => {
    // Normalize and ensure we look after "/viewSurvey/"
    const marker = "/editSurvey/";
    const idx = pathname.toLowerCase().indexOf(marker.toLowerCase());
    if (idx === -1) return null;

    // Take everything after /viewSurvey/
    const rest = pathname.slice(idx + marker.length);

    // In case there are query strings or hashes (rare for path usage)
    const cleaned = rest.split(/[?#]/)[0];

    // Now split into segments
    const [propertyMasterId, inspectionRefNo, doorNumber] = cleaned.split("/");

    if (!propertyMasterId || !inspectionRefNo || !doorNumber) return null;

    return { propertyMasterId, inspectionRefNo, doorNumber };
  };

  const handleCheckEditSurvey = async(url) => {
    const params = parseSurveyPath(url);
    try {
      const doorData = await http.get(
        GET_DOOR_INSPECTION_DATA +
          params?.doorNumber +
          "&propertyMasterId=" +
          propertyMasterId + "&inspectionRefNumber=" + inspectionRefnumber
      );
      if (doorData?.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "An inspection for this door already exists, redirecting to edit survey",
        });
        setTimeout(() => {
          gotoEditSurvey(params?.doorNumber, url);
        }, 2001);
      }
    } catch (err) {
      if (err.status === 404) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString:
            "Survey linked is not yet submitted. Redirecting to new survey for the same",
        });
        setTimeout(() => {
            gotoDashBoardMapped(params?.doorNumber, url);
          }, 2001);
      }
    }
  }

  const stopScanning = () => {
    setIsScanning(false);
    if (html5QrCodeRef?.current?.isScanning) {
      html5QrCodeRef.current
        .stop()
        .then(() => html5QrCodeRef.current.clear())
        .catch((err) => console.error("Stop Scan Error:", err));
    }
  };
  const handleChange = (e) => {
    stopScanning();
    setSelectedCameraId(e.target.value);
  };

  const handleCancel = () => {
    navigate(
      generatePath("/client/:clientNameParam/property-form", {
        clientNameParam,
      })
    );
  };
  const gotoDashBoard = () => {
    const pathTemplate =
      "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyMasterId,
      inspectionRefnumber: inspectionRefnumber,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoDashBoardMapped = (doorRef, mappedUrl) => {
      const urlTouse = mappedUrl.split("Survey/")[1];
      const pathTemplate = `/client/:clientNameParam/dashboard/${urlTouse}`;
      const params = {
        clientNameParam: clientNameParam,
      };
  
      const fullPath = generatePath(pathTemplate, params);
      navigate(fullPath);
    };

  const gotoDashBoardLinked = (doorRef) => {
    const pathTemplate =
      "/client/:clientNameParam/dashboard/:propertyMasterId/:inspectionRefnumber/:doorRefNumber";
    const params = {
      clientNameParam: clientNameParam,
      propertyMasterId: propertyMasterId,
      inspectionRefnumber: inspectionRefnumber,
      doorRefNumber: doorRef,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  const gotoEditSurvey = (doorRef, mappedUrl) => {
    const urlTouse = mappedUrl.split("Survey/")[1];
    const pathTemplate = `/client/:clientNameParam/editSurvey/${urlTouse}`;
    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);
    navigate(fullPath);
  };

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      {userObj && (
        <div className="dashboard_body_main">
          <LoadingComponent loading={isLoading} />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            {!scanOpen && (
              <div className="modal-overlay">
                <div
                  className="approval-modal-content"
                  style={{ height: "fit-content" }}
                >
                  <span className="close" onClick={handleCancel}>
                    &times;
                  </span>
                  <h6 className="modal-header">Select</h6> {/* Modal Header */}
                  <div className="modal-body">
                    <div className="card-body action_btns d-flex justify-content-center flex-column gap-3 flex-wrap flex-sm-nowrap">
                      <button
                        type="button"
                        className="btn-primary"
                        onClick={() => setScanOpen(true)}
                      >
                        Scan QR Code
                      </button>
                      <button
                        type="button"
                        className="btn-secondary"
                        onClick={() => {
                          gotoDashBoard();
                        }}
                      >
                        Manual Survey
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {scanOpen && (
              <div
                className={`${
                  renderInComponent
                    ? "render-scanner"
                    : "no-render-scanner mb-3"
                } mx-auto`}
              >
                <div className="form-floating mb-3">
                  <select
                    className="form-select"
                    name="doorType"
                    id="floatingSelect"
                    aria-label="Floating label select example"
                    value={selectedCameraId || ""}
                    onChange={handleChange}
                  >
                    {cameras.map((cam) => (
                      <option key={cam.id} value={cam.id}>
                        {cam.label}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="floatingSelect">Camera</label>
                </div>

                <div
                  id="reader"
                  style={{ width: "100%", margin: "20px auto" }}
                />

                <div className="d-flex gap-3">
                  {isScanning == false && (
                    <button
                      className="btn-primary flex-fill"
                      type="button"
                      onClick={startScanning}
                    >
                      Start Scanning
                    </button>
                  )}

                  {isScanning == true && (
                    <button
                      className=" btn-primary flex-fill"
                      type="button"
                      onClick={stopScanning}
                    >
                      Stop Scanning
                    </button>
                  )}
                  {isSafari && scannedLink && (
                    <button
                      type="button"
                      className=" btn-secondary"
                      onClick={() => window.open(scannedLink, "_blank")}
                    >
                      Open Scanned Link
                    </button>
                  )}
                  {!renderInComponent && (
                    <button
                      type="button"
                      className=" btn-secondary flex-fill"
                      onClick={() => {
                        handleCancel();
                      }}
                    >
                      Back to Dashboard
                    </button>
                  )}
                </div>
                <div>
                  {/* <input type="file" className="btn btn-secondary w-auto w-100 flex-grow-1" accept="image/*" onChange={scanImageFile} /> */}
                  {/* <strong>Door Reference Link:</strong> <a href={scannedText || "None"}>{scannedText}</a> */}
                </div>
              </div>
            )}

            {showAuditPopup && (
              <div className="modal-overlay">
                <div
                  className="approval-modal-content d-flex flex-column"
                  style={{
                    width: "80%",
                    maxWidth: "1200px",
                    maxHeight: "80vh",
                  }}
                >
                  <div className="d-flex justify-content-end align-items-center px-3 pt-2 flex-shrink-0">
                    <span
                      className="close me-4 mt-3"
                      style={{ fontSize: "14px", cursor: "pointer" }}
                      onClick={() => handleLinkQRCode(auditDoorRef)}
                    >
                      Start Survey →
                    </span>
                    <span
                      className="close mt-2"
                      style={{ fontSize: "22px", cursor: "pointer" }}
                      onClick={handleCancel}
                    >
                      &times;
                    </span>
                  </div>
                  <h6 className="modal-header flex-shrink-0 mb-0">
                  Door Inspection History
                  </h6>
                  <div className="modal-body overflow-auto flex-grow-1">
                    <div className="card-body action_btns d-flex justify-content-center flex-column gap-3 flex-wrap flex-sm-nowrap">
                      <QrAuditTrail
                        QRrRefNumber={auditDoorRef}
                        propertyId={propertyMasterId}
                        inspectionRefNumber={inspectionRefnumber}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={() => {
              closeButton();
            }}
          />
          <Footer />
          <div className="bottom-bar-spacing"></div>
          <BottomBarIcons />
        </div>
      )}
    </>
  );
};

export default ScanLinkQRCode;
